function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#102E8E"
}), React.createElement("path", {
  d: "M12 12h24v24H12z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M31 18.41L29.59 17 24 22.59 18.41 17 17 18.41 22.59 24 17 29.59 18.41 31 24 25.41 29.59 31 31 29.59 25.41 24z"
}));

var SvgIcCloseLarge = function SvgIcCloseLarge(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiMxMDJFOEUiLz4KICAgICAgICA8cGF0aCBkPSJNMTIgMTJoMjR2MjRIMTJ6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZD0iTTMxIDE4LjQxTDI5LjU5IDE3IDI0IDIyLjU5IDE4LjQxIDE3IDE3IDE4LjQxIDIyLjU5IDI0IDE3IDI5LjU5IDE4LjQxIDMxIDI0IDI1LjQxIDI5LjU5IDMxIDMxIDI5LjU5IDI1LjQxIDI0eiIvPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIcCloseLarge as ReactComponent };